module.exports = __webpack_public_path__ + "img/img4.e245cc70.png";